module.exports = __webpack_public_path__ + "img/about_content_002_pc.9199e489.png";